import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import useReplicate from "./useReplicate";
import usePrepareReplicate from "./usePrepareReplicate";
import { ReplicateActionContext } from "./ReplicateActionContext";

function useReplicateAction(getFunction: any): any {
  const prepareReplicate = usePrepareReplicate();
  const prepareReplicateFunction = (id: any) => prepareReplicate(id);

  const replicate = useReplicate();
  const replicateFunction = () => replicate((newInvoiceId: number) => {
    getFunction(newInvoiceId);
  });

  const contextInstance = useContext(ReplicateActionContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "replicate_invoice",
    onSubmit: () => replicateFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t("are_you_sure_you_want_to_replicate_this_invoice?")}
    </CrudModuleFactoryModal>
  );

  return {
    prepareReplicateFunction,
    actionTemplate,
  };
}

export default useReplicateAction;
